import React from "react";
import RSelect, { components as SelectComponents } from "react-select";
import { customStyles, customTheme } from "./styles";

// add menuPortalTarget for fixing dropdown overlap issues. Details: https://github.com/JedWatson/react-select/issues/3263#issuecomment-604237097
// add menuShouldBlockScroll for fixing dropdown menu not following scroll event. Details: https://github.com/JedWatson/react-select/issues/3734
const Select = ({ ...props }) => <RSelect theme={customTheme} styles={customStyles} {...props} />;

export { Select, SelectComponents };
